import React, {useEffect} from 'react';
import Board from "./Board";
import {useDispatch, useSelector} from "react-redux";
import Player from "./Player";
import PointBar from "./PointBar";
import RoomModal from "./RoomModal";
import {setRoomTabNotifier} from "../../../redux/actions/rooms/actions";
import useSound from "use-sound";
import Buttons from "./Player/Buttons/index.jsx";

const Room = function ({roomId, isActive}) {
    const entered = useSelector(state => state.rooms);
    const audioEnabled = useSelector(state => state.lobby.audioEnabled);
    const {id: userId, currency, isMobile, avatar: avatarIndex} = useSelector(state => state.user);
    const room = entered[roomId];
    const opponentId = room?.round?.opponentId;
    const dispatch = useDispatch();
    const players = room?.round?.players;
    let topPlayer = players && ((room?.isViewRoom) ? players[room?.opponentId] : players[opponentId]);
    let bottomPlayer = players && ((room?.isViewRoom) ? players[room?.playerId] : players[userId]);
    if (room?.historyRoomPlayer === topPlayer?.platformId) {
        bottomPlayer = players?.[room?.historyRoomPlayer];
        topPlayer = players?.[room?.playerId]
    }
    const [playShuffle] = useSound('/audio/cards-shuffle.m4a', {
            volume: 1,
            playbackRate: 1.2,
            soundEnabled: isActive && audioEnabled
        });
        const [playCardBita ] = useSound('/audio/card-slide.m4a', {
            volume: 1,
            playbackRate: 1.2,
            soundEnabled: isActive && audioEnabled
        });
        const [playCardSound] = useSound('/audio/play-card.m4a', {
            volume: 1,
            playbackRate: 1.4,
            soundEnabled: isActive && audioEnabled
        });
    useEffect(() => {
        if (room?.historyRoomPlayer) return;

        if (room?.round?.activePlayerPlatformId === userId && !isActive) {
            dispatch(setRoomTabNotifier({roomId: roomId}));
        }
    }, [room?.round?.activePlayerPlatformId, room?.historyRoomPlayer, isActive, roomId, userId, dispatch]);
    return (
        <div className={`game ${isActive ? 'active' : 'inActive'}`}>
            <div className="game__wrapper">
                <div className="room--wrapper">
                    {!isMobile && <div className="room__ratio"/>}
                    <div className={"board"}>
                        <div className="board__wrapper">
                            {!isMobile &&
                                <div className="board__view">
                                    <span className="board__view--wrapper"></span>
                                </div>
                            }
                            <div className={`board__content ${room?.isViewRoom ? 'board__content-view-room' : ''}`}>
                                {
                                    topPlayer && (
                                        <Player
                                            playerData={topPlayer}
                                            playable={false}
                                            top={true}
                                            position={'top'}
                                            isViewRoom={room?.isViewRoom || room?.historyRoomPlayer}
                                            avatarIndex = {topPlayer?.avatar || 1}
                                            nickName = {topPlayer?.platformId}
                                            timers={room?.timers}
                                            isActive={topPlayer?.platformId === room?.round?.activePlayerPlatformId}
                                        />
                                    )
                                }
                                <RoomModal
                                    roomId={roomId}
                                    userId={userId}
                                    currency={currency}
                                />

                                {
                                    ((room?.status === 'PROGRESS' && !room?.historyRoomPlayer) || room?.historyRoomPlayer) &&
                                    <div className="board__center">
                                        <PointBar
                                            points={room?.points}
                                            topPlayerId={topPlayer?.platformId}
                                            bottomPlayerId={bottomPlayer?.platformId}
                                            roomId={room?.roomId}
                                            conventions={room?.conventions}
                                            isInGame={userId === bottomPlayer?.platformId}
                                            currency={currency}
                                            isTournament={room?.tournamentId}
                                        />
                                        <Board
                                            roomId={roomId}
                                            topCards={topPlayer?.cards || []}
                                            bottomCards={bottomPlayer?.cards || []}
                                            trump={room?.round?.trump}
                                            boardWinnerId={room?.round?.boardWinnerId}
                                            bottomPlayerId={bottomPlayer?.platformId}
                                            topPlayerId={topPlayer?.platformId}
                                            playedCards={room?.round?.playedCards}
                                            activePlayerId={room?.round?.activePlayerPlatformId}
                                            hiddenBitaCards={room?.round?.hiddenBitaCards}
                                            selectedCombinationCards={room?.selectedCombinationCards}
                                            cardsSelectable={room?.cardsSelectable}
                                            isViewRoom={room?.isViewRoom || room?.historyRoomPlayer}
                                            publishedCombinationCards={room?.round?.publishedCombinationCards}
                                            resetHand={room?.round?.resetHand}
                                            playShuffle={playShuffle}
                                            playCardBita={playCardBita}
                                            playCardSound={playCardSound}
                                        />
                                    </div>
                                }
                                {
                                    bottomPlayer && (
                                        <Player
                                            playable={bottomPlayer.platformId === userId && (!room?.isHistoryRoom && !room.historyRoomPlayer)}
                                            playerData={bottomPlayer}
                                            canPassAllCardsToMe={room?.round?.canPassAllCardsToMe}
                                            canPassAllCardsToYou={room?.round?.canPassAllCardsToYou}
                                            conventionIndexes={room?.conventions?.indexes}
                                            top={false}
                                            isViewRoom={room?.isViewRoom || room?.historyRoomPlayer}
                                            position={'bottom'}
                                            avatarIndex = {userId === bottomPlayer?.platformId ? avatarIndex : (bottomPlayer?.avatar || 1)}
                                            nickName = {userId === bottomPlayer?.platformId ?  userId : bottomPlayer?.platformId}
                                            timers={room?.timers}
                                            isActive={bottomPlayer?.platformId === room?.round?.activePlayerPlatformId}
                                        >
                                            <Buttons
                                                isActive={bottomPlayer?.isActive}
                                                roomId={bottomPlayer?.roomId}
                                                conventionIndexes={room?.conventions?.indexes}
                                                canAnnounceCombination={bottomPlayer?.canAnnounceCombination}
                                                canShowCombination={bottomPlayer?.canShowCombination}
                                                canPassAllCardsToYou={room?.round?.canPassAllCardsToYou}
                                                canPassAllCardsToMe={room?.round?.canPassAllCardsToMe}
                                                playable={bottomPlayer.platformId === userId && (!room?.isHistoryRoom && !room.historyRoomPlayer)}
                                            />
                                        </Player>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Room
